// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CityContext$PorterinFeature from "./CityContext.mjs";

var provider = CityContext$PorterinFeature.context.Provider;

function CityProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var make = CityProvider;

export {
  provider ,
  make ,
}
/* provider Not a pure module */
